import { store } from '@/state/store';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';

export function FN_IMAGE__get_image_under_mask_for(field: FIELD__image_asset) {
  let { generation_current } = store.getState().slice_generation;

  if (generation_current.is_stub()) return FIELD__image_asset.CREATE_STUB();

  let out = generation_current.tool.graph.field_image__get_under_mask_for(field);

  return out;
}
